import { NasIcon } from './NasIcon';

/**
 * author: Simran
 * id 001157C4-1AAA-41FF-B204-906ACDB427C3
 * name nas
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/nas.svg
 * tags
 */
export const NetworkAttachedStorageIcon = NasIcon;
export default NetworkAttachedStorageIcon